/**
 * SEOHelmet — Reusable meta tag component for any page.
 * Adds title, description, OG tags, Twitter cards, and optional JSON-LD.
 */

import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://commerceindex.com';
const SITE_NAME = 'Commerce Index';

export function SEOHelmet({ title, description, path = '/', jsonLd = null, type = 'website', image = null }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Agentic Commerce OS`;
  const fullUrl = `${SITE}${path}`;
  const ogImage = image || `${SITE}/og-image.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || 'Commerce Index is an agentic commerce operating system with 80+ AI agents. Manage supply chain, marketing, finance, and compliance from a text message.'} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}

export default SEOHelmet;
